import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../../utils/withRouter";
import { ToastContainer, toast } from "react-toastify";
import {
  multi_purpose_centre_list_action,
  multi_purpose_centre_delete_action,
} from "../../../actions/master_actions/multiPurposeCentre_action";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../../../utils/Loader";
import Header from "../../../common_components/Header";
import { fill_action } from "../../../actions/fillList_action";
import { Pagination } from "react-bootstrap";
import { sessionExpireMessage, tokenInavlidMessage } from "../../../utils/constants";
class MultiPurposeCentre extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      userId: "",
      CenterID: "",
      Code: "",
      Name: "",
      CityName: "",
      StateName: "",
      CountryName: "",
      Status: "",
      multiCentreData: [],
      isAccordionExpanded: false,
      currentPage: 1,
    };
    this.handleDelete = this.handleDelete.bind(this);
    this.multiCentreList = this.multiCentreList.bind(this);
    this.updateItem = this.updateItem.bind(this);
    this.navigateMultiCentreAdd = this.navigateMultiCentreAdd.bind(this);
    this.navigateMultiCentreUpdate = this.navigateMultiCentreUpdate.bind(this);
  }
  componentDidMount() {
    if (JSON.parse(sessionStorage.getItem("UserLoginData")) == null) {
      console.log("log");
      setTimeout(() => {
        this.props.navigate("/login");
      }, 500);
    }
    setTimeout(() => {
      {
        sessionStorage.getItem("roleId") == 4 ? (
          this.props.navigate("/checkList")
        ) : (
          <></>
        );
      }
    }, 10);
    const { userId } = this.state;
    this.setState({
      userId:
        sessionStorage.getItem("userId") == "" ||
        sessionStorage.getItem("userId") == null
          ? ""
          : sessionStorage.getItem("userId"),
    });
    this.multiCentreList();
  }

  navigateMultiCentreUpdate(CenterID,Status) {
    this.props.navigate("/multi_purpose_centre_add", {
      state: { CenterID: CenterID,Status:Status },
    });
  }

  navigateMultiCentreAdd() {
    const { multiCentreData } = this.state;
    const maxCode = Math.max(
      ...multiCentreData.map((center) => parseInt(center.Code.substring(1), 10))
    );
    let newCode;
    if (maxCode < 9) {
      newCode = `C00${maxCode + 1}`;
    } else if (maxCode < 99) {
      newCode = `C0${maxCode + 1}`;
    } else {
      newCode = `C${maxCode + 1}`;
    }
    this.props.navigate("/multi_purpose_centre_add", {
      state: { Code: newCode },
    });
  }
  multiCentreList = async () => {
    const {
      multiCentreData,
      userId,
      Code,
      Name,
      CityName,
      StateName,
      CountryName,
      Status,
    } = this.state;
    this.setState({ isLoading: true });
    const finalStatus =
      Status == "InActive" ? 0 : Status == "Active" ? 1 : null;
    this.props
      .multi_purpose_centre_list_action(
        Code,
        Name,
        CityName,
        StateName,
        CountryName,
        finalStatus
      )
      .then((data) => {
        console.log(data, "from UI MultiCentre");
        if (data.error !== 1) {
          data.data.sort((a, b) => a.Code.localeCompare(b.Code));
          this.setState({
            multiCentreData: data.data,
            isLoading: false,
            currentpage: 1,
          });
        } else {
          if(data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage){
            //after session expire.....................
            sessionStorage.clear()
            this.props.navigate('/normalView')
            setTimeout(() => {
              toast.error(data.msg, {
                position:"top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }, 500);
        }else{
          toast.error(data.msg, {
            position: "top-center",
            theme: "colored",
            autoClose: 3000,
            hideProgressBar: true,
          });
        }}
      })
      .catch((e) => {
        console.log(e);
      });
    setTimeout(() => {
      console.log(multiCentreData);
    }, 500);
  };
  handleDelete(CenterID) {
    const { userId } = this.state;
    const confirmed = window.confirm(
      "Are you sure you want to delete this Multi-Purpose Centre?"
    );

    if (confirmed) {
      this.props
        .multi_purpose_centre_delete_action(userId, CenterID)
        .then((data) => {
          if (data.error !== 1) {
            toast.success("Data Deleted Successfully", {
              position: "top-center",
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
            this.multiCentreList(); // Refresh the holiday list after deletion
          } else {
            if(data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage){
              //after session expire.....................
              sessionStorage.clear()
              this.props.navigate('/normalView')
              setTimeout(() => {
                toast.error(data.msg, {
                  position:"top-center",
                  theme: "colored",
                  autoClose: 3000,
                  hideProgressBar: true,
                });
              }, 500);
          }else{
            toast.error(data.msg, {
              position: "top-center",
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
          }}
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }
  centerRecord(multiCentreData) {
    // const { userList } =this.state
    return (
      <table
        className="table table-bordered table-striped"
        id="dashboard-table"
      >
        <thead>
          <tr>
            <th>Center Code</th>
            <th>Center Name</th>
            <th>City</th>
            <th>State</th>
            <th>Country</th>
            <th>Status</th>
            <th className="text-right" style={{ width: "5%" }}>
              Action
            </th>
          </tr>
        </thead>
        <tbody id="myTable">
          {multiCentreData.length > 0
            ? multiCentreData.map((data) => (
                <tr>
                  <td>{data.Code}</td>
                  <td>{data.Name}</td>
                  <td>{data.CityName}</td>
                  <td>{data.StateName}</td>
                  <td>{data.CountryName}</td>
                  <td>{data.Status}</td>
                  <td className="text-right">
                    <a
                      href="javascript:void(0);"
                      onClick={() => {
                        console.log("data.CenterID:", data.CenterID);
                        this.navigateMultiCentreUpdate(data.CenterID,data.Status);
                      }}
                      title="Edit"
                      className="btn btn-sm"
                    >
                      <i className="fa fa-edit action_btn_table" />
                    </a>
                    {data.Status=="Active"?(

                      <a
                      onClick={() => this.handleDelete(data.CenterID)}
                      title="Delete"
                      className="btn btn-sm delete_record"
                      >
                      <i className="fa fa-trash action_btn_table" />
                    </a>
                    ):<></>}
                  </td>
                </tr>
              ))
            : null}
        </tbody>
      </table>
    );
  }
  updateItem(item) {
    this.setState({ currentPage: item });
  }

  render() {
    const {
      multiCentreData,
      isLoading,
      userId,
      Code,
      Name,
      CityName,
      StateName,
      CountryName,
      Status,
      isAccordionExpanded,
      currentPage,
    } = this.state;
    const recordsPerPage = 10;
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    // Records to be displayed on the current page
    const currentRecords = multiCentreData.slice(
      indexOfFirstRecord,
      indexOfLastRecord
    );
    const nPages = Math.ceil(multiCentreData.length / recordsPerPage);
    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <>
          <main id="main">
            <Header data={[17]} />
            <section style={{ marginTop: 115 }}>
              <div className="container-fluid">
                <div className="page-header">
                  <h4 className="page-title">Multi-Purpose Center’s List</h4>
                  <div>
                    <a
                      href="javascript:void(0);"
                      onClick={() => this.navigateMultiCentreAdd()}
                      className="btn btn-primary btn-sm create_btn"
                    >
                      <span className="hidden-xs">Add</span>
                    </a>
                  </div>
                </div>
                <div className="search_accordion search_card">
                  <div className="panel-group" id="accordion">
                    <div className="panel panel-default">
                      <div
                        className="panel-heading accordion-toggle collapsed"
                        data-toggle="collapse"
                        data-parent="#accordion"
                        data-target="#collapseOne"
                        aria-expanded={isAccordionExpanded}
                        onClick={() =>
                          this.setState({
                            isAccordionExpanded: !isAccordionExpanded,
                          })
                        }
                      >
                        <h4 className="panel-title">Search</h4>
                        <div className="searched_items">
                          <h5>
                            Center Code : <span>{Code}</span>
                          </h5>
                          <h5>
                            Center Name : <span>{Name}</span>
                          </h5>

                          <h5>
                            Status : <span>{this.state.Status}</span>
                          </h5>
                          {/* <div class="chip">
              John Doe <span class="closebtn" onclick="this.parentElement.style.display='none'">&times;</span>
            </div> */}
                        </div>
                      </div>
                      <div
                        id="collapseOne"
                        className={`panel-collapse collapse ${
                          isAccordionExpanded ? "show" : ""
                        }`}
                        aria-labelledby="headingOne"
                      >
                        <div className="panel-body">
                          <div className="row mr_0">
                            <div className="col-md-2">
                              <div className="form-group">
                                <label>Center Code</label>
                                <input
                                  value={Code}
                                  onChange={(e) =>
                                    this.setState({ Code: e.target.value })
                                  }
                                  type="text"
                                  className="form-control search_form_control"
                                  placeholder="Enter Center Code"
                                />
                              </div>
                            </div>
                            <div className="col-md-2">
                              <div className="form-group">
                                <label>Center Name</label>
                                <input
                                  value={Name}
                                  onChange={(e) =>
                                    this.setState({ Name: e.target.value })
                                  }
                                  type="text"
                                  className="form-control search_form_control"
                                  placeholder="Enter Center Name"
                                />
                              </div>
                            </div>

                            <div className="col-md-2">
                              <div className="form-group">
                                <label>Status</label>
                                <select
                                  className="form-control"
                                  value={Status}
                                  onChange={(e) =>
                                    this.setState({ Status: e.target.value })
                                  }
                                >
                                  <option value="">--Select--</option>
                                  <option value="Active">Active</option>
                                  <option value="InActive">Inactive</option>
                                </select>
                              </div>
                            </div>
                            <div className="col-md-4">
                              <label>&nbsp;</label>
                              <button
                                onClick={() => this.multiCentreList()}
                                className="btn btn-primary search_btn"
                              >
                                Search
                              </button>
                              &nbsp;&nbsp;
                              <button
                                onClick={() => window.location.reload()}
                                className="btn btn-primary search_btn"
                              >
                                Clear Filters
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="custom_table">
                  <div className="hack1">
                    <div className="hack2">
                      {this.centerRecord(currentRecords)}
                      {multiCentreData.length > 0 ? (
                        <Pagination
                          nPages={nPages}
                          currentPage={currentPage}
                          setCurrentPage={this.updateItem}
                        />
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </main>
          <ToastContainer />
        </>
      </>
    );
  }
}
export default withRouter(
  connect(null, {
    multi_purpose_centre_list_action,
    multi_purpose_centre_delete_action,
    fill_action,
  })(MultiPurposeCentre)
);
